var activeElement = 0;

var accordionMenu = $('.accordion-menu');
var accordionMenuLinks = $('.accordion-menu .accordion-item-title');
var accordingMenuList = $('.accordion-menu ul');

accordionMenuLinks.each(function (index, element) {
    if ($(element).hasClass('open')) {
        activeElement = index;
    }
});

accordingMenuList.each(function (index, element) {
    if ($(element).hasClass('open')) {
        activeElement = index;
    }
});

if (accordionMenu.hasClass('click')) {
    accordionMenu.accordion({
        heightStyle: 'content',
        event: 'click',
        active: activeElement,
        beforeActivate: function (event, ui) {
            return false;
        }
    });

    accordionMenu.find('a').click(function (event) {
        window.location.href = $(this).attr("href");
    });

} else if (accordionMenu.hasClass('click-toggle')) {
    accordionMenu.accordion({
        heightStyle: 'content',
        event: 'click',
        active: activeElement,
        collapsible: true,
    });

    // jQuery UI preventDefault()-s every header click, and (when collapsible
    // is off, the default) returns before even calling beforeActivate for a
    // header that is already active - which is exactly the case on pages
    // where no category matches the current slug (e.g. /faq, /blog index),
    // since the first header is then active by default. So beforeActivate
    // can't be relied on here: bind a plain, independent click handler
    // instead for categories with no subitems (blog sections, FAQ, some
    // guide-energie categories) - those are plain navigation links, not
    // accordion triggers, and preventDefault() doesn't stop this handler.
    accordionMenu.find('.accordion-item-title').each(function () {
        var header = $(this);
        var hasSubitems = header.next('ul').find('.accordion-item').length > 0;
        var href = header.attr('href');
        if (!hasSubitems && href && href !== 'javascript:void(0)') {
            header.on('click', function () {
                window.location.href = href;
            });
        }
    });

} else {
    accordionMenu.accordion({
        heightStyle: 'content',
        event: 'mouseover',
        active: activeElement,
    });
}